module.exports = __webpack_public_path__ + "static/media/verify.7e7e910e.svg";